/* Partner Übersicht: Bereichsfilter und Kopier-Button für Partner-Codes.
   Ohne JS sind alle Karten sichtbar und der Kopier-Button bleibt verborgen. */
(function () {
  'use strict';

  function initFilter(root) {
    var chips = root.querySelectorAll('[data-pu-filter]');
    var karten = root.querySelectorAll('[data-pu-raster] [data-bereich]');
    var status = root.querySelector('[data-pu-status]');
    if (!chips.length || !karten.length) return;

    function anwenden(filter) {
      var sichtbar = 0;
      karten.forEach(function (karte) {
        var passt = filter === 'alle' || karte.getAttribute('data-bereich') === filter;
        if (passt) {
          karte.removeAttribute('hidden');
          sichtbar += 1;
        } else {
          karte.setAttribute('hidden', '');
        }
      });
      chips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', chip.getAttribute('data-pu-filter') === filter ? 'true' : 'false');
      });
      if (status) {
        status.textContent = sichtbar === 1 ? '1 Partner' : sichtbar + ' Partner';
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        anwenden(chip.getAttribute('data-pu-filter'));
      });
    });
  }

  function kopieren(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var feld = document.createElement('textarea');
      feld.value = text;
      feld.setAttribute('readonly', '');
      feld.style.position = 'fixed';
      feld.style.opacity = '0';
      document.body.appendChild(feld);
      feld.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(feld);
      ok ? resolve() : reject();
    });
  }

  function initKopieren(root) {
    root.querySelectorAll('[data-pu-kopieren]').forEach(function (knopf) {
      knopf.removeAttribute('hidden');
      var standard = knopf.textContent;
      knopf.addEventListener('click', function () {
        var code = knopf.getAttribute('data-code') || '';
        kopieren(code).then(function () {
          knopf.textContent = 'Kopiert';
          knopf.classList.add('ist-kopiert');
          window.setTimeout(function () {
            knopf.textContent = standard;
            knopf.classList.remove('ist-kopiert');
          }, 2000);
        }).catch(function () {
          knopf.textContent = 'Bitte manuell kopieren';
          window.setTimeout(function () { knopf.textContent = standard; }, 2500);
        });
      });
    });
  }

  function init(root) {
    if (!root || root.dataset.puBereit === '1') return;
    root.dataset.puBereit = '1';
    initFilter(root);
    initKopieren(root);
  }

  function alle() {
    document.querySelectorAll('[data-partner-uebersicht]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector('[data-partner-uebersicht]');
    if (root) init(root);
  });
})();
